import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AssetActionControlService } from './asset-action-control.service';
import { AssetActionControlRequest } from './dto/asset-action-control.dto';
import { AssetCodeDto } from './dto/asset-code.dto';
import { AssetControlRequest } from './dto/asset-control.req';

@ApiTags('asset-action-control')
@Controller('asset-action-control')
export class AssetActionControlController {
    constructor(private readonly applicationExceptionHandler: ApplicationExceptionHandler,
        private service: AssetActionControlService) { }

    @Post('/saveAssetAction')
    async saveAssetAction(@Body() reqObj: AssetActionControlRequest) {
        console.log('ffffff')
        console.log(reqObj)
        return await this.service.saveAssetAction(reqObj);
    } 
    
    @Post('/getLatestActionOfAsset')
    async getLatestActionOfAsset(@Body() reqObj: AssetCodeDto) {
        return await this.service.getLatestActionOfAsset(reqObj);
    } 
    @Post('/stopAssets')
    async stopAssets(@Body() reqObj: AssetControlRequest) {
        return await this.service.stopAssets(reqObj);
    } 
    @Post('/assetActiveSoaking')
    async assetActiveSoaking(): Promise<CommonResponse> {
      try {
        return await this.service.assetActiveSoaking();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }

    @Post('/getSoakingMachineDashboardData')
    async getSoakingMachineDashboardData() {
        return await this.service.getSoakingMachineDashboardData();
    } 
}
